var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg500Ml(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#47464A",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeWidth: 0.25,
    d: "M40.966 13.942v-6.26a3.56 3.56 0 0 0-3.557-3.557h-9.818a3.562 3.562 0 0 0-3.558 3.557v6.261l-.1.123a5.97 5.97 0 0 0-3.048 1.638 5.972 5.972 0 0 0-1.76 4.25v34.363a6.018 6.018 0 0 0 6.011 6.012h14.728a6.019 6.019 0 0 0 6.011-6.012V19.954a6.022 6.022 0 0 0-4.81-5.89l-.1-.122zm-14.728-6.26c0-.746.606-1.352 1.353-1.352h9.818c.746 0 1.352.606 1.352 1.352v6.136l-.125.125H26.363l-.125-.125V7.682zM43.67 25.799v28.518c0 2.1-1.707 3.808-3.806 3.808H25.136a3.812 3.812 0 0 1-3.806-3.808V25.8l.125-.125h22.09l.125.125zm-.125-2.038h-22.09l-.125-.125v-3.682c0-1.017.395-1.973 1.113-2.691a3.781 3.781 0 0 1 2.691-1.114l14.73-.001a3.81 3.81 0 0 1 3.806 3.806v3.682l-.125.125z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg500Ml);
export default __webpack_public_path__ + "static/media/500_ml.7ec00844d52e30cd119c349ea8e7bb0a.svg";
export { ForwardRef as ReactComponent };